
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const SELLER_REGISTER_REQUEST = 'REGISTER_REQUEST';
export const SELLER_REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const SELLER_REGISTER_FAILURE = 'REGISTER_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const OTP_REQUEST = 'OTP_REQUEST';
export const OTP_SUCCESS = 'OTP_SUCCESS';
export const OTP_FAILURE = 'OTP_FAILURE';

export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const GET_USER_WITH_ACTIVE_ADDRESS_REQUEST = 'GET_USER_WITH_ACTIVE_ADDRESS_REQUEST';
export const GET_USER_WITH_ACTIVE_ADDRESS_SUCCESS = 'GET_USER_WITH_ACTIVE_ADDRESS_SUCCESS';
export const GET_USER_WITH_ACTIVE_ADDRESS_FAILURE = 'GET_USER_WITH_ACTIVE_ADDRESS_FAILURE';

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_FAILURE = 'USER_UPDATE_PROFILE_FAILURE';

export const LOGOUT = 'LOGOUT';